// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__f2sFJ","title":"BackImages_title__19vd4","images":"BackImages_images__FeYNO"};